import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { fetchContracts } from "../../../store/middleware";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import { setContract } from "../../../store/slices/b2b/b2bContracts.slice";
import Placeholder from "../../../components/Placeholder/PlaceholderByPage";

import { TableUser } from "../companies/styles";

function ContractsList({ setShowContractForm }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contracts } = useSelector((state) => state.b2bContractsReducer);

  const emptyFilter = {
    pageNumber: 1,
    pageSize: 100,
    code: "",
    companyId: "",
    economicGroupId: "",
    startDate: "",
    endDate: "",
    active: "",
  };

  const loadInfos = () => dispatch(fetchContracts(emptyFilter));

  const setSelected = (item, contract) => {
    let newContract = contract;
    if (item.contracts && item.contracts.length > 0) {
      dispatch(
        fetchContracts({
          pageNumber: 1,
          pageSize: 100,
          code: newContract.code,
          companyId: "",
          economicGroupId: "",
          startDate: "",
          endDate: "",
          active: "",
        }),
      ).then(async (res) => {
        let cont = res[0];
        let contractDetails = {
          ...newContract,
          economicGroup: cont.economicGroup,
          economicGroupId: cont.economicGroupId,
          socialName: cont.socialName,
          companyId: cont.contracts[0].companyId,
          contractPlans: cont.contracts[0].contractPlans,
          contractContacts: cont.contracts[0].contractContacts,
        };

        await dispatch(setContract(contractDetails));
        setShowContractForm(true);
      });
    }
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <TableUser>
      <div className="bigBox">
        <table>
          <thead>
            <tr>
              <th>{t("CONTRACT_NUMBER")}</th>
              <th>{t("ECONOMIC_GROUP")}</th>
              <th>{t("COMPANY")}</th>
              <th>{t("DESCRIPTION")}</th>
              <th>{t("PERIOD")}</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {contracts.map((item) => {
              return item.contracts.map((contract) => {
                return (
                  <tr key={JSON.stringify(contract)}>
                    <td data-id={contract.id}>{contract.code}</td>
                    <td>{decryptIfEncrypted(item.economicGroup.name)}</td>
                    <td>{item.socialName}</td>
                    <td>{contract.description}</td>
                    <td>
                      {contract.startDate} - {contract.endDate}
                    </td>
                    <td>
                      <span className={!contract.active ? "inativo" : ""}>
                        {contract.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <button type="button" onClick={() => setSelected(item, contract)}>
                        {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>

      {contracts.length === 0 && (
        <div style={{ paddingTop: "50px" }}>
          <Placeholder pageName="users" textMsg="Nothing here yet" />
        </div>
      )}
    </TableUser>
  );
}

export default ContractsList;
